import { mergeClasses } from '@blank/utilities'
import { StepIcon } from './StepIcon'

export type SignupStepStatus = 'done' | 'editing' | 'todo'

interface Props {
  label: string
  value?: string
  status?: SignupStepStatus
  stepNumber: number
}
export const Step = ({ label, value, status = 'todo', stepNumber }: Props) => {
  return (
    <div className="signup-stepper-container">
      <div
        className={mergeClasses(
          'flex flex-auto space-x-6 px-2 py-2 text-white',
          { 'rounded-l-4xl rounded-r-lg bg-primary-600': status === 'editing' }
        )}
      >
        <div className="flex flex-initial flex-col items-center">
          <div>
            <StepIcon stepNumber={stepNumber} stepStatus={status} />
          </div>
        </div>
        <div className="flex flex-col justify-center overflow-hidden">
          <p className={mergeClasses({ 'text-xs': value })}>{label}</p>
          {value && (
            <p
              className="overflow-hidden text-ellipsis font-bold"
              data-amp-mask=""
            >
              {value}
            </p>
          )}
        </div>
      </div>
      <span className="signup-stepper-line ml-7 block h-9 w-0.5 bg-white" />
    </div>
  )
}
